import { SanityRichTextBlock } from 'types/sanity';

export const minNumberOfGrowthDataPointsToShow = 6;
export const minNumberOfDividendDataPointsToShow = 3;

export const growthTechFooter: Array<SanityRichTextBlock> = [
	{
		_key: '6ae984231a51',
		_type: 'block',
		children: [
			{
				_key: 'ef2b9f3edabb0',
				_type: 'span',
				marks: [],
				text: 'Source: '
			},
			{
				_key: '5d550ccc7db7',
				_type: 'span',
				marks: ['7dd8fb6436cd'],
				text: 'https://differentfunds.com/state-of-terms-2018'
			}
		],
		level: 1,
		listItem: 'number',
		markDefs: [
			{
				_type: 'link',
				_key: '7dd8fb6436cd',
				openInNewTab: false,
				url: 'https://differentfunds.com/state-of-terms-2018'
			}
		],
		style: 'normal'
	},
	{
		_key: '396ace0de88a',
		_type: 'block',
		children: [
			{
				_key: 'd8f0b31640750',
				_type: 'span',
				marks: [],
				text: 'The Fundrise Innovation Fund is the marketing name for the underlying legal entity, Fundrise Growth Tech Fund, LLC.'
			}
		],
		markDefs: [],
		style: 'normal'
	},
	{
		_key: 'a89f89765058',
		_type: 'block',
		children: [
			{
				_key: 'ddf2b0f1f8140',
				_type: 'span',
				marks: [],
				text: 'A portion of distributions may be a direct result of expense support payments provided by Fundrise Advisors, which are subject to repayment by the Fund within three years. The purpose of this arrangement is to ensure that the Fund bears an appropriate level of expenses. Any such distributions may not be entirely based on investment performance and can only be sustained if positive investment performance is achieved in future periods and/or Fundrise Advisors continues to make such expense support payments. Future repayments will reduce cash otherwise potentially available for distributions. There can be no assurance that such performance will be achieved in order to sustain these distributions. Fundrise Advisors has no obligation to provide expense support payments in future periods.'
			}
		],
		markDefs: [],
		style: 'normal'
	},
	{
		_key: 'd286c32a11bd',
		_type: 'block',
		children: [
			{
				_key: '86dff35c3ba90',
				_type: 'span',
				marks: [],
				text: 'The Fund may fund distributions from unlimited amounts of offering proceeds or borrowings, which may constitute a return of capital, as well as net income from operations, capital and non-capital gains from the sale of assets, dividends or distributions from equity investments and expense support payments from Fundrise Advisors, which are subject to repayment. The sources of distributions may vary periodically. Please refer to the semi-annual or annual reports that will be filed with the SEC for the sources of distributions.'
			}
		],
		markDefs: [],
		style: 'normal'
	},
	{
		_key: 'cb1e22c54899',
		_type: 'block',
		children: [
			{
				_key: '5a2759a8041f0',
				_type: 'span',
				marks: [],
				text: 'Past performance is no guarantee of future results. Any historical returns, expected returns, or probability projections may not reflect actual future performance. All securities involve risk and may result in partial or total loss. While the data we use from third parties is believed to be reliable, we cannot ensure the accuracy or completeness of data provided by investors or other third parties. Neither Fundrise nor any of its affiliates provide tax advice and do not represent in any manner that the outcomes described herein will result in any particular tax consequence. Prospective investors should confer with their personal tax advisors regarding the tax consequences based on their particular circumstances. Neither Fundrise nor any of its affiliates assume responsibility for the tax consequences for any investor of any investment.'
			}
		],
		markDefs: [],
		style: 'normal'
	},
	{
		_key: '9e6537aa83b5',
		_type: 'block',
		children: [
			{
				_key: '5daa902f788f0',
				_type: 'span',
				marks: [],
				text: 'The Fundrise Innovation Fund is the marketing name for the underlying legal entity, Fundrise Growth Tech Fund, LLC.'
			}
		],
		markDefs: [],
		style: 'normal'
	}
];

export const intervalFundFooter: Array<SanityRichTextBlock> = [
	{
		_key: '9959d2ace2ee',
		children: [
			{
				_type: 'span',
				marks: [],
				text: 'Current distribution rate is expressed as a percentage equal to the currently declared distribution amount on an annualized basis (which is calculated by annualizing the current daily cash distribution per share without compounding), divided by the relevant net asset value per share. The current distribution rate shown may be rounded.',
				_key: '15cdeee5cc1b0'
			}
		],
		markDefs: [],
		_type: 'block',
		style: 'normal'
	},
	{
		_key: '6b6dff2f008e',
		children: [
			{
				_type: 'span',
				marks: [],
				text: 'A portion of distributions may be a direct result of expense support payments provided by Fundrise Advisors, which are subject to repayment by the Fund within three years. The purpose of this arrangement is to ensure that the Fund bears an appropriate level of expenses. Any such distributions may not be entirely based on investment performance and can only be sustained if positive investment performance is achieved in future periods and/or Fundrise Advisors continues to make such expense support payments. Future repayments will reduce cash otherwise potentially available for distributions. There can be no assurance that such performance will be achieved in order to sustain these distributions. Fundrise Advisors has no obligation to provide expense support payments in future periods.',
				_key: '5fa9356017230'
			}
		],
		markDefs: [],
		_type: 'block',
		style: 'normal'
	},
	{
		_key: '868589f0316b',
		children: [
			{
				_type: 'span',
				marks: [],
				text: "The Fund may fund distributions from unlimited amounts of offering proceeds or borrowings, which may constitute a return of capital, as well as net income from operations, capital and non-capital gains from the sale of assets, dividends or distributions from equity investments and expense support payments from Fundrise Advisors, which are subject to repayment. The sources of distributions may vary periodically. Please refer to the semi-annual or annual reports that will be filed with the SEC, or the Fund's Distribution Notices, for the sources of distributions. Investors will separately be informed of the tax characteristics of any distributions they receive.",
				_key: '2d07043780b20'
			}
		],
		markDefs: [],
		_type: 'block',
		style: 'normal'
	},
	{
		_key: '3ca95925f073',
		children: [
			{
				_type: 'span',
				marks: [],
				text: 'The Fund may be purchased as either part of an investment plan by Fundrise Advisors or individually.',
				_key: '96a6ba1cd2900'
			}
		],
		markDefs: [],
		_type: 'block',
		style: 'normal'
	},
	{
		_key: '4e321693bc31',
		children: [
			{
				_type: 'span',
				marks: [],
				text: 'Past performance is no guarantee of future results. Any historical returns, expected returns, or probability projections may not reflect actual future performance. All securities involve risk and may result in partial or total loss. While the data we use from third parties is believed to be reliable, we cannot ensure the accuracy or completeness of data provided by investors or other third parties. Neither Fundrise nor any of its affiliates provide tax advice and do not represent in any manner that the outcomes described herein will result in any particular tax consequence. Prospective investors should confer with their personal tax advisors regarding the tax consequences based on their particular circumstances. Neither Fundrise nor any of its affiliates assume responsibility for the tax consequences for any investor of any investment.',
				_key: '4b292786e4150'
			}
		],
		markDefs: [],
		_type: 'block',
		style: 'normal'
	}
];

export const lifetimeAnnualizedReturnTooltip = `Annualized return since inception is calculated as a compound average annual return of the fund from the fund's inception date to the most recent month-end. Returns are a sum of NAV appreciation and dividends.`;
export const threeYearAnnualizedReturnTooltip =
	'3-year annualized return is calculated as a compound average annual return of the fund over the last 36 months ending in the most recent month-end. Returns are a sum of NAV appreciation and dividends.';
